import { Component, OnInit } from '@angular/core';
import { trigger, transition, animate, style, state, group } from '@angular/animations';

@Component( {
    selector: 'cp-acadia-docs',
    templateUrl: './acadia-docs.component.html',
    styleUrls: [ './acadia-docs.component.scss' ],
    animations: [
        /*trigger(
            'inOutAnimation',
            [
                transition(
                    ':enter',
                    [
                        style({ height: 0, opacity: 0 }),
                        animate('1s ease-out',
                            style({ height: 40, opacity: 1 }))
                    ]
                ),
                transition(
                    ':leave',
                    [
                        style({ height: 300, opacity: 1 }),
                        animate('1s ease-in',
                            style({ height: 0, opacity: 0 }))
                    ]
                )
            ]
        )*/
    ]
} )
export class AcadiaDocsComponent implements OnInit {

    public state: number = 1;

    constructor() {
    }

    ngOnInit() {
    }

    acadiaView( state ) {
        this.state = state;
    }

}
